import React from 'react';
import './OrderListPrimeReact.css';
import './MarketPlace.css';
import GeneralUtils from "../../shared/utils/GeneralUtils";
import MemberSectionPanel from "../../shared/component/MemberSectionPanel";
import 'react-tabs-scrollable/dist/rts.css'
import {Card} from 'primereact/card';
import MarketPlaceService from "../../shared/service/MarketPlaceService";
import {InputText} from "primereact/inputtext";
import ModalConfirm from "../../shared/component/dialog/ModalConfirm";
import Loading from "../../shared/component/others/Loading";

export default class MarketPlace extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            branches: [],
            favoriteBranchesOfUser: [],
            loading: false,
            searchText: "",
            itemSub: null
        };
        this.marketPlaceService = new MarketPlaceService();
        this.handlePopState = this.handlePopState.bind(this);
    }

    componentDidMount = () => {
        window.addEventListener('popstate', this.handlePopState);
        this.refreshList();
    }

    componentWillUnmount() {
        window.removeEventListener('popstate', this.handlePopState);
    }

    handlePopState() {
        if (this.state.displayShowStatusConfirmDialog) {
            this.setState({displayShowStatusConfirmDialog: false});
        }
    }


    isBranchFavoriteOfUser(id) {
        let favoriteBranchesOfUser = this.state.favoriteBranchesOfUser;
        if (!favoriteBranchesOfUser || favoriteBranchesOfUser.length === 0) {
            return false;
        }
        const nid = Number(id);
        for (var i = 0; i < favoriteBranchesOfUser.length; i++) {
            const fid = favoriteBranchesOfUser[i];
            if (fid === id || Number(fid) === nid) {
                return true;
            }
        }
        return false;
    }

    getBranchAccentColor(itemSub) {
        if (!GeneralUtils.isNullOrEmpty(itemSub.menuBorderColor)) {
            const color = String(itemSub.menuBorderColor).trim();
            return color.startsWith('#') ? color : `#${color}`;
        }
        return '#00bcd4';
    }

    renderCardList(isFavorite) {
        let form = [];

        if (this.state.branches != undefined && !GeneralUtils.isNullOrEmpty(this.state.branches) && this.state.branches.length > 0) {
            this.state.branches.forEach(itemSub => {
                let isBranchFavoriteOfUser = this.isBranchFavoriteOfUser(itemSub.id);
                if ((isFavorite == false && isBranchFavoriteOfUser == false) || (isFavorite == true && isBranchFavoriteOfUser == true) || (isFavorite == null)) {
                    form.push(
                        <div
                            key={itemSub.id}
                            onClick={() => this.clickItem(itemSub, isBranchFavoriteOfUser)}
                            className="marketplace-card-wrap"
                            style={{"--member-accent": this.getBranchAccentColor(itemSub)}}
                        >
                            {this.renderFavIcon(itemSub, isBranchFavoriteOfUser)}
                            <Card
                                className="marketplace-store-card"
                                header={this.renderCardImage(itemSub)}
                            >
                                <div className="marketplace-store-body">
                                    <div className="marketplace-store-title">{itemSub.tradingName}</div>
                                    {!GeneralUtils.isNullOrEmpty(itemSub.displayAddressString) && (
                                        <div className="marketplace-store-address">{itemSub.displayAddressString}</div>
                                    )}
                                    <div className="marketplace-store-meta">
                                        {this.renderMetaLine(itemSub.postCodeAround)}
                                        {this.renderMetaLine(itemSub.serviceableAreas)}
                                        {this.renderMetaLine(itemSub.openAndCloseHours)}
                                    </div>
                                </div>
                            </Card>
                        </div>);
                }


            });
        }
        return form;
    }

    hasCardListItems(isFavorite) {
        if (this.state.branches == undefined || GeneralUtils.isNullOrEmpty(this.state.branches) || this.state.branches.length === 0) {
            return false;
        }
        for (let i = 0; i < this.state.branches.length; i++) {
            const itemSub = this.state.branches[i];
            const isBranchFavoriteOfUser = this.isBranchFavoriteOfUser(itemSub.id);
            if ((isFavorite === false && !isBranchFavoriteOfUser)
                || (isFavorite === true && isBranchFavoriteOfUser)
                || isFavorite == null) {
                return true;
            }
        }
        return false;
    }

    renderMetaLine(text) {
        if (GeneralUtils.isNullOrEmpty(text)) {
            return null;
        }
        return <div className="marketplace-meta-line">{text}</div>;
    }

    renderCardImage(item) {
        const logoUrl = this.marketPlaceService.getLogoUrl(item.id, item.logoUrl);
        return (
            <div className="image-container marketplace-card-logo">
                <img
                    src={logoUrl}
                    onError={(e) => {
                        e.target.src = "assets/layout/images/white.png";
                    }}
                    alt={item.tradingName || item.name || ""}
                />
            </div>
        );
    }

    render() {
        let form = [];
        form.push(this.renderList());
        form.push(this.state.loading && <Loading></Loading>)

        return form;
    }

    renderMarketplaceSection(title, isFavorite) {
        if (!this.hasCardListItems(isFavorite)) {
            return null;
        }
        const sectionKey = isFavorite === true ? 'favorites' : isFavorite === false ? 'other' : 'all';
        return (
            <MemberSectionPanel
                key={`marketplace-section-${sectionKey}`}
                title={title}
                sectionId={sectionKey}
                collapsible
                className="marketplace-section-panel"
                bodyClassName="marketplace-section-panel__body"
            >
                <div className="marketplace-grid">
                    {this.renderCardList(isFavorite)}
                </div>
            </MemberSectionPanel>
        );
    }

    renderList() {
        let form = [];
        form.push(<ModalConfirm header='Warning' ok='OK' onOkClick={this.clickFavIcon}
                                onCancelClick={() => this.setState({displayShowStatusConfirmDialog: false})}
                                show={this.state.displayShowStatusConfirmDialog}
                                message={this.state.noticeResponse}/>);
        form.push(this.renderSearchText());

        if (GeneralUtils.isAuthenticated()) {
            form.push(this.renderMarketplaceSection('Your Favorites', true));
            form.push(this.renderMarketplaceSection('Other Stores', false));
        } else {
            form.push(this.renderMarketplaceSection('Stores', null));
        }


        return form;
    }


    refreshList() {
        this.setState({loading: true});


        this.marketPlaceService.findAll().then(response => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                this.setState({
                    branches: response,
                    loading: false
                });

            } else {
                this.setState({
                    branches: [],
                    loading: false
                });
            }
        });

        if (GeneralUtils.isAuthenticated() && !GeneralUtils.isNullOrEmpty(localStorage.getItem("appMode")) && localStorage.getItem("appMode") == "member")  {
            this.marketPlaceService.findFavoriteBranchesOfUser().then(response => {
                /* Backend List<Long> — JSON array. Boş [] için isNullOrEmpty true olduğundan state hiç güncellenmezdi; silinen son favori ekranda kalırdı */
                if (Array.isArray(response)) {
                    this.setState({
                        favoriteBranchesOfUser: response,
                    });
                } else if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                    this.setState({
                        favoriteBranchesOfUser: response,
                    });
                }
            })
        }


    }

    renderFavIcon(itemSub, isBranchFavoriteOfUser) {
        if (GeneralUtils.isAuthenticated()) {
            if (isBranchFavoriteOfUser) {
                return <i
                    onClick={(e) => this.showChangeStatusConfirmDialog(e, itemSub, "Do you want to remove from your favorites?")}
                    className="pi pi-star marketplace-fav-btn"
                    role="button"
                    aria-label="Remove from favorites"
                />;
            } else {
                return <i
                    onClick={(e) => this.showChangeStatusConfirmDialog(e, itemSub, "Do you want to add to your favorites?")}
                    className="pi pi-star-o marketplace-fav-btn"
                    role="button"
                    aria-label="Add to favorites"
                />;
            }
        }

    }

    renderSearchText() {

        let form = [];
        form.push(<div className="marketplace-search-bar">

            <div style={{ textAlign: "center" }}>


                <InputText value={this.state.searchText}
                           placeholder="Search stores by name"
                           onChange={this.__handleChangeSearchText}/>
            </div>
        </div>);


        return form;

    }

    showChangeStatusConfirmDialog = (e, itemSub, text) => {
        this.setState({
            displayShowStatusConfirmDialog: true,
            noticeResponse: text,
            itemSub: itemSub
        }, () => {
            window.history.pushState({marketplaceOverlay: true}, document.title, window.location.href);
        });
        e.stopPropagation();
    }

    clickFavIcon = () => {
        var makeFavorite = true;
        let itemSub = this.state.itemSub;
        if (!GeneralUtils.isNullOrEmpty(itemSub)) {
            if (this.isBranchFavoriteOfUser(itemSub.id)) {
                makeFavorite = false;
            }

            this.marketPlaceService.updateFavoriteBranch(itemSub.id, makeFavorite)
                .then((response) => {
                    this.refreshList();
                });
        }


    }

    clickItem(itemSub, isBranchFavoriteOfUser) {

        this.setState({loading: true});
        if (GeneralUtils.isAuthenticated() && !isBranchFavoriteOfUser) {
            this.marketPlaceService.updateFavoriteBranch(itemSub.id, true)
                .then((response) => {
                    if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                    }
                });
        }
        //localStorage.removeItem("basketBssId");
        localStorage.setItem("merchantBranchId", itemSub.id);
        this.setState({loading: false});
        window.location.href = "/" + itemSub.domainName

    }

    __handleChangeSearchText = async (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        this.setState({searchText: value});
        if (!GeneralUtils.isNullOrEmpty(value) && value.length > 3) {
            this.setState({branches: []});

            const response = (await this.marketPlaceService.findAllBySearchText(value));
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.status)) {
                this.setState({
                    branches: response,
                    loading: false
                });
            } else {
                this.setState({
                    branches: [],
                    loading: false
                });
            }
        } else {
            this.refreshList();

        }

    }


}
